import React from "react";

export const TransformationTable = ({ dataBase }) => {
	return (
		<div className="containerInventory04">
			<table className="tabla-process">
				<thead>
					<tr className="fila-tabla-inventory">
						<th className="titulo-tabla-inventory">Fecha</th>
						<th className="titulo-tabla-inventory"># Proceso</th>
						<th className="titulo-tabla-inventory">Responsable</th>
						<th className="titulo-tabla-inventory">Productos Salen</th>
						<th className="titulo-tabla-inventory">Productos Entran</th>
					</tr>
				</thead>

				<tbody>
					{dataBase.map((transfer, index) => (
						<tr key={index} className="fila-tabla-cuenstas">
							<td className="col-tabla-inventory1">{transfer.date}</td>

							<td className="col-tabla-inventory1">{transfer.processNumber}</td>
							<td className="col-tabla-inventory1">{transfer.user}</td>
							<td className="col-tabla-inventory2">
								{transfer.initialProducts.map((product) => (
									<h3 className="titulo4">
										{product.amount} - {product.description}
									</h3>
								))}
							</td>
							<td className="col-tabla-inventory2">
								{transfer.finalProducts.map((product) => (
									<h3 className="titulo4">
										{product.amount} - {product.description}
									</h3>
								))}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
